import SocketIO, { Manager } from 'socket.io-client';

export default {
  /**
   * Find all store actions with `socket_` prefix and register listeners.
   * Then bind `$socket` client to to Vue.
   */
  install(Vue, options) {
    const {
      store,
      actionPrefix = 'socket_',
    } = options;

    Vue.prototype.$manager = new Manager(process.env.SOCKETS_URL, {
      path: '/s',
      port: 443,
      secure: true,
      withCredentials: true,
    });

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$socket = Vue.prototype.$manager.socket('/producer');

    const actions = store._actions; // eslint-disable-line no-underscore-dangle
    const socketActions = Object.keys(actions).filter((name) => name.indexOf(actionPrefix) === 0);

    // Setup reconnect handler, which is only available on the Manager.
    Vue.prototype.$manager.on('reconnect', (...args) => {
      // Proxy to socket_reconnect store action
      store.dispatch('socket_reconnect', ...args);
    });

    socketActions.forEach((action) => {
      const eventName = action.substr(actionPrefix.length);

      Vue.prototype.$socket.on(eventName, (...args) => {
        store.dispatch(action, ...args);
      });
    });

    window.$manager = Vue.prototype.$manager;
    window.$socket = Vue.prototype.$socket;
  },
};
